<template>
    <div class="modal fade " id="incluirViagem" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered ">
            <div class="modal-content" style="background-color: #292994; width: 75% !important; border-radius: 20px;">
                <div class="modal-header" style="border-color:#292994 !important; padding-left: 55px;">
                    <div class="offset-md-4">
                        <h5 class="modal-title title-font" id="exampleModalLabel"
                            style="color:white;text-align: center;">Incluir Viagem
                        </h5>
                    </div>
                </div>
                <div class="modal-body modal-body-incluirviagen" style="padding-left:30px">
                    <div style="color: #fff; width: 90%; margin-left: 20px;  margin-top: -3%;">
                        <div class="top-viagem">
                            <div>
                                <v-select 
                                    :disabled="emptyOption(linhas)"
                                    class="select_incluir shadow-light" id="select-viagem" label="codigo"
                                    placeholder="Linhas" :options="linhas" v-model="selectedOptionLinha"
                                    @update:modelValue="changeLinha()">
                                </v-select>

                            </div>

                            <div class="input-group" style="width: 140px !important;">
                                <input type="text" class="form-control select_incluir shadow-light" style="text-align: center;"
                                    aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default"
                                    placeholder="Posição" v-model="selectedOptionPosicao">
                            </div>

                            <div>
                                <v-select 
                                    :disabled="emptyOption(atividades)"
                                    class="select_incluir shadow-light" id="select-viagem" label="alias"
                                    placeholder="Atividade" :options="atividades" v-model="selectedOptionAtividade">
                                </v-select>
                            </div>
                        </div>

                        <div class="div1 responsive-div-incluir"
                            v-if="this.selectedOptionAtividade.alias != 'retornogaragem' && this.selectedOptionAtividade != ''"
                            style="margin-top:20px">
                            <div>
                                <h7 class="header-with-line-ida">IDA</h7>
                            </div>
                            <div class="container-viagem">
                                <div class="top-viagem">
                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(itinerariosIda)"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Itinerario" :options="itinerariosIda"
                                            v-model="selectedIdaItinerario" @update:modelValue="changeDiv1('itinerariosIda')">
                                        </v-select>
                                    </div>

                                    <div v-if="selectedOptionAtividade.alias != 'saidagaragem'">
                                        <v-select 
                                            :disabled="isDisabledPointsGo"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Inicio" :options="pontosIda"
                                            v-model="selectedIdaPontoInicio" @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>

                                    <div v-else>
                                        <v-select 
                                            :disabled="isDisabledPointsGo"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Inicio" :options="pontosGaragem"
                                            v-model="selectedIdaPontoInicio" @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="isDisabledPointsGo"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Fim" :options="pontosIda"
                                            v-model="selectedIdaPontoFim" @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="middle-viagem" margin-top:20px>
                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(veiculos)"
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Veiculo" :options="veiculos" v-model="selectedIdaVeiculo"
                                            @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(motoristas)"
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Motorista" :options="motoristas"
                                            v-model="selectedIdaMotorista" @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(cobradores)"    
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Cobrador" :options="cobradores"
                                            v-model="selectedIdaCobrador" @update:modelValue="changeDiv1()">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="bottom-viagem">
                                    <div class="input-group" style="width: 135px !important; margin-right: 50px;">
                                        <input type="time" class="form-control select_incluir  shadow-light"
                                            style="color: #292994; text-align: center;"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-default" placeholder="00:00"
                                            v-model="hora_saida_ida" @change="changeDiv1">
                                    </div>

                                    <div class="input-group" style="width: 135px !important;">
                                        <input type="time" class="form-control select_incluir  shadow-light"
                                            style="color: #292994; text-align: center;"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-default" placeholder="00:00"
                                            v-model="hora_chegada_ida" @change="changeDiv1">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="div2 responsive-div-incluir" 
                            v-if="this.selectedOptionAtividade.alias != 'saidagaragem' && this.selectedOptionAtividade != ''" style="margin-top:20px">
                            <div style="text-align:center">
                                <h7 class="header-with-line-volta">VOLTA</h7>
                            </div>

                            <div class="container-viagem">
                                <div class="top-viagem">
                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(itinerariosVolta)"    
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Itinerario" :options="itinerariosVolta"
                                            v-model="selectedVoltaItinerario" @update:modelValue="changeDiv2('itinerariosVolta')">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="isDisabledPointsBack"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Inicio" :options="pontosVolta"
                                            v-model="selectedVoltaPontoInicio" @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>

                                    <div v-if="this.selectedOptionAtividade.alias != 'retornogaragem'">
                                        <v-select 
                                            :disabled="isDisabledPointsBack"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Fim" :options="pontosVolta"
                                            v-model="selectedVoltaPontoFim" @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>

                                    <div v-else>
                                        <v-select 
                                            :disabled="isDisabledPointsBack"
                                            class="select_incluir shadow-light" id="select-viagem" label="nome"
                                            placeholder="Ponto Fim" :options="pontosGaragem"
                                            v-model="selectedVoltaPontoFim" @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="middle-viagem">
                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(veiculos)"  
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Veiculo" :options="veiculos" v-model="selectedVoltaVeiculo"
                                            @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(motoristas)"  
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Motorista" :options="motoristas"
                                            v-model="selectedVoltaMotorista" @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>

                                    <div>
                                        <v-select 
                                            :disabled="emptyOption(cobradores)"  
                                            class="select_incluir shadow-light" id="select-viagem" label="alias"
                                            placeholder="Cobrador" :options="cobradores"
                                            v-model="selectedVoltaCobrador" @update:modelValue="changeDiv2()">
                                        </v-select>
                                    </div>
                                </div>
                                <div class="bottom-viagem">
                                    <div class="input-groupt" style="width: 140px !important;  margin-right: 50px;">
                                        <input type="time" class="form-control select_incluir  shadow-ligh"
                                            style="color: #292994; text-align: center;"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-default" placeholder="00:00"
                                            v-model="hora_saida_volta" @change="changeDiv2">
                                    </div>

                                    <div class="input-group" style="width: 140px !important;">
                                        <input type="time" class="form-control select_incluir  shadow-light"
                                            style="color: #292994; text-align: center;"
                                            aria-label="Sizing example input"
                                            aria-describedby="inputGroup-sizing-default" placeholder="00:00"
                                            v-model="hora_chegada_volta" @change="changeDiv2">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" style="padding:0 !important">
                    <div style="margin: auto">
                        <button @click="submitForm()" type="button"
                            class="btn custom-background-green-light custom-background-blue-dark text-weight btn-custom-list shadow-light btngreen">Aplicar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './../../../assets/css/operacoes/incluir-viagem.css';
import http from '../../../services/http.js';

export default {
    name: 'incluirviagem',
    data: () => {
        return {
            veiculos: [],
            motoristas: [],
            id_empresa: null,
            linhas: [],
            atividades: [],
            itinerarios: [],
            itinerariosIda: [],
            itinerariosVolta: [],
            pontosIda: [],
            pontosVolta: [],
            isDisabledPointsGo: false,
            isDisabledPointsBack: false,
            selectedIdaPontoInicio: null,
            selectedIdaPontoFim: null,
            cobradores: '',

            selectedOptionAtividade: '',
            beforeAtividade: '',
            selectedOptionLinha: '',
            selectedOptionPosicao: '',

            div1Filled: false,
            selectedIdaItinerario: '',
            selectedIdaPontoInicio: '',
            selectedIdaPontoFim: '',
            selectedIdaVeiculo: '',
            selectedIdaMotorista: '',
            selectedIdaCobrador: '',
            hora_saida_ida: '',
            hora_chegada_ida: '',

            div2Filled: false,
            selectedVoltaItinerario: '',
            selectedVoltaPontoInicio: '',
            selectedVoltaPontoFim: '',
            selectedVoltaVeiculo: '',
            selectedVoltaMotorista: '',
            selectedVoltaCobrador: '',
            hora_saida_volta: '',
            chegada_volta: '',

            date: '',
            vif: '',
            date_time_now: '',
            range_time: '',
            pontosGaragem: []

        }
    },
    mounted() {
        this.emitter.on("incluirViagem", (data) => {
            this.emptyModal();
            this.date = data.date;
            this.veiculos = data.vehicles;
            this.id_empresa = data.id_empresa;

            data.drivers.forEach(e => {
                if (e.tipo == 'motorista') this.motoristas.push(e);
            })
            console.log("test")
            this.setData();
            $("#incluirViagem").modal("show");
        });

        this.isDisabledPointsGo = true;
        this.isDisabledPointsBack = true;

        this.emitter.on('incluirViagemDateTime', data => {
            this.date_time_now = moment(data[0], 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            this.range_time = data[1];
        })

    },
    methods: {
        setData() {
            http.get('operation/actives', { params: { orgid: this.id_empresa } })
                .then((res) => {
                    this.atividades = res.data.dados;
                }).catch((err) => console.error(err));

            http.get('operation/lines', { params: { orgid: this.id_empresa } })
                .then((res) => {
                    this.linhas = res.data.dados;
                }).catch((err) => console.error(err));
                this.emptyModal();
        },
        changeLinha() {
            this.selectedIdaItinerario = '';
            this.selectedVoltaItinerario = '';
            this.selectedIdaPontoInicio = '';
            this.selectedIdaPontoFim = '';
            this.selectedVoltaPontoInicio = '';
            this.selectedVoltaPontoFim = '';

            this.itinerarios = [];
            this.itinerariosIda = [];
            this.itinerariosVolta = [];

            this.pontosIda = [];
            this.pontosGaragem = [];
            this.pontosVolta = [];

            http.get('operation/itinerary', { params: { orgid: this.id_empresa, linha_id: this.selectedOptionLinha.id } })
                .then((res) => {
                    this.itinerarios = res.data.dados;                    

                    this.itinerarios.forEach(e => {
                        if (e.sentido == 'i') this.itinerariosIda.push(e);
                        if (e.sentido == 'v') this.itinerariosVolta.push(e);
                    })

                }).catch((err) => console.error(err));
        },
        salvarViagem() {
            // REALIZANDO FORMATAÇÃO PARA ENVIO DE OUTROS CAMPOS NECESSÁRIOS
            var data = this.date;
            var previsao_hora_saida_ida = moment(data+' '+this.hora_saida_ida, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            var previsao_hora_chegada_ida = moment(data+' '+this.hora_chegada_ida, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');

            var previsao_hora_saida_volta = moment(data+' '+this.hora_saida_volta, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
            var previsao_hora_chegada_volta = moment(data+' '+this.hora_chegada_volta, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'); 

            var objectViagem = {
                orgid: this.id_empresa,
                linha: this.selectedOptionLinha.id,
                posicao: this.selectedOptionPosicao,
                atividade: this.selectedOptionAtividade.alias,

                itinerarioIda: this.selectedIdaItinerario.id,
                
                pontoInicioIda: this.selectedIdaPontoInicio.id,
                pontoFimIda: this.selectedIdaPontoFim.id,

                ida_nome_ponto_saida: this.selectedIdaPontoInicio.nome,
                ida_nome_ponto_chegada: this.selectedIdaPontoFim.nome,
                veiculoIda: this.selectedIdaVeiculo != null ? this.selectedIdaVeiculo.id : null,
                motoristaIda: this.selectedIdaMotorista != null ? this.selectedIdaMotorista.id : null,
                cobradorIda: this.selectedIdaCobrador,
                hora_saida_ida: this.hora_saida_ida,
                hora_chegada_ida: this.hora_chegada_ida,
                previsao_hora_saida_ida: previsao_hora_saida_ida,
                previsao_hora_chegada_ida: previsao_hora_chegada_ida,

                itinerarioVolta: this.selectedVoltaItinerario.id,
                pontoInicioVolta: this.selectedVoltaPontoInicio.id,
                pontoFimVolta: this.selectedVoltaPontoFim.id,
                
                volta_nome_ponto_saida: this.selectedVoltaPontoInicio.nome,
                volta_nome_ponto_chegada: this.selectedVoltaPontoFim.nome,
                veiculoVolta: this.selectedVoltaVeiculo.id,
                motoristaVolta: this.selectedVoltaMotorista.id,
                cobradorVolta: this.selectedVoltaCobrador,
                hora_saida_volta: this.hora_saida_volta,
                hora_chegada_volta: this.hora_chegada_volta,
                previsao_hora_saida_volta: previsao_hora_saida_volta,
                previsao_hora_chegada_volta: previsao_hora_chegada_volta,
                date: this.date != null ? this.date : moment().format('YYYY-MM-DD'),
                date_time_now: this.date_time_now,
                range: this.range_time
            };
            http.post('operation/insert/trip', objectViagem)
                .then((res) => {
                    if (res.data.status) {                            
                        $("#incluirViagem").modal("hide");
                        this.$toast.success(`Viagem salva com sucesso!`);
                        this.emitter.emit('updateIncluirViagem', res.data.dados);
                        this.emptyModal();
                     }else {
                        this.$toast.error(`Viagem não foi salva.`);
                     }
                }).catch(error => console.error(error));
        },
        emptyModal() {
            this.div1Filled = false;
            this.div2Filled = false;

            this.selectedOptionLinha = '';
            this.selectedOptionPosicao = '';
            this.selectedOptionAtividade = '';

            this.selectedIdaItinerario = '';
            this.selectedIdaPontoInicio = '';
            this.selectedIdaPontoFim = '';
            this.selectedIdaPontoInicio = '';
            this.selectedIdaPontoFim = '';
            this.selectedIdaVeiculo = '';
            this.selectedIdaMotorista = '';
            this.selectedIdaCobrador = '';
            this.hora_saida_ida = '';
            this.hora_chegada_ida = '';

            this.selectedVoltaItinerario = '';
            this.selectedVoltaPontoInicio = '';
            this.selectedVoltaPontoFim = '';
            this.selectedVoltaPontoInicio = '';
            this.selectedVoltaPontoFim = '';
            this.selectedVoltaVeiculo = '';
            this.selectedVoltaMotorista = '';
            this.selectedVoltaCobrador = '';
            this.hora_saida_volta = '';
            this.hora_chegada_volta = '';
        },
        changeDiv1(nome = null) {
            if (nome == 'itinerariosIda') {
                http.get('operation/points/itinerary', {
                    params: { 
                        orgid: this.id_empresa, 
                        id_points: this.selectedIdaItinerario.pontos_parada_ids, 
                        id_itinerario: this.selectedIdaItinerario.id,
                        tipo: this.selectedOptionAtividade.alias
                    }
                }).then((response) => {
                        this.pontosIda = response.data.dados.pontos_itinerarios;
                        if (this.pontosIda.length > 0) this.isDisabledPointsGo = false;

                        this.pontosGaragem = response.data.dados.pontos_garagem;
                        this.filterPonintsIda(this.selectedOptionAtividade.alias);

                    }).catch(error => console.log(error));
            }

            this.div1Filled = true;
        },
        changeDiv2(nome = null) {
            this.div2Filled = true;

            if (nome == 'itinerariosVolta') {
                http.get('operation/points/itinerary', {
                        params: { 
                            id_points: this.selectedVoltaItinerario.pontos_parada_ids, 
                            orgid: this.id_empresa, 
                            id_itinerario: this.selectedVoltaItinerario.id,
                            tipo: this.selectedOptionAtividade.alias
                        }
                    }).then((response) => {
                        this.pontosVolta = response.data.dados.pontos_itinerarios;
                        if (this.pontosVolta.length > 0) this.isDisabledPointsBack = false;
    
                        this.pontosGaragem = response.data.dados.pontos_garagem;
                        this.filterPonintsVolta(this.selectedOptionAtividade.alias)
                    }).catch(error => console.log(error));                
            }

        },
        filterPonintsIda(tipo) {
            if (tipo == 'viagemregular' || tipo == 'viagemextra') {
                this.selectedIdaPontoInicio = this.pontosIda[0];
                this.selectedIdaPontoFim = this.pontosIda[this.pontosIda.length -1];
            }
            if (tipo == 'saidagaragem') {
                this.selectedIdaPontoInicio = this.pontosGaragem[0];
                this.selectedIdaPontoFim = this.pontosIda[0];
            }
        },
        filterPonintsVolta(tipo) {
            if (tipo == 'viagemregular' || tipo == 'viagemextra') {
                this.selectedVoltaPontoInicio = this.pontosVolta[0]; 
                this.selectedVoltaPontoFim = this.pontosVolta[this.pontosVolta.length -1];
            }
            if (tipo == 'retornogaragem') {
                this.selectedVoltaPontoInicio =  this.pontosVolta[this.pontosVolta.length - 1];
                this.selectedVoltaPontoFim = this.pontosGaragem[0];
            }
        },
        submitForm() {
            if (this.div1Filled && !this.validateDiv1()) {
                return this.$toast.error(`É necessario preencher todos os dados da IDA!`);
            }

            if (this.div2Filled && !this.validateDiv2()) {
                return this.$toast.error(`É necessario preencher todos os dados da VOLTA!`);
            }
            this.salvarViagem()
        },
        validateDiv1() { return this.selectedIdaItinerario !== '' && this.selectedIdaPontoInicio !== '' && this.selectedIdaPontoFim !== '' && this.hora_saida_ida !== '' && this.hora_chegada_ida !== ''; },
        validateDiv2() { return this.selectedVoltaItinerario !== '' && this.selectedVoltaPontoInicio !== '' && this.selectedVoltaPontoFim !== '' && this.hora_saida_volta !== '' && this.hora_chegada_volta !== ''; },
        emptyOption(data) { return data.length === 0 },
    },
}
</script>